export default {
  title: "Saldo",
  descriptionDefault: "Verfolgen Sie Ihre Einnahmen und Transaktionen",
  descriptionFull: "Alle Transaktionen für Ihre Aktivitäten verfolgen",
  hostIdMissing: "Gastgeber-Benutzer-ID nicht gefunden",
  salesAgentIdMissing: "Vertriebsagenten-Benutzer-ID nicht gefunden",
  sellerIdMissing: "Verkäufer-Benutzer-ID nicht gefunden",
  loadingBalance: "Saldo-Daten werden geladen...",
  errorLoad: "Fehler beim Laden der Wallet-Daten",
  statCurrentBalance: "Aktueller Saldo",
  statAmountOwed: "Geschuldeter Betrag",
  statTotalIncome: "Einnahmen im Zeitraum",
  statTotalExpenses: "Ausgaben im Zeitraum",
  statTransactions: "{{count}} Transaktionen im Zeitraum",
  periodLabel: "Zeitraum",
  filtersTitle: "Suchfilter",
  filtersActive_one: "{{count}} Filter aktiv",
  filtersActive_other: "{{count}} Filter aktiv",
  filtersHint: "Filter setzen, um Ergebnisse einzugrenzen",
  dateRange: "Datumsbereich",
  from: "Von",
  to: "Bis",
  searchCriteria: "Suchkriterien",
  searchDescriptionLabel: "In Beschreibung suchen",
  searchDescriptionPlaceholder: "Transaktionen suchen...",
  activityLabel: "Aktivität",
  allActivities: "Alle Aktivitäten",
  amountRange: "Betragsbereich",
  minAmount: "Mindestbetrag (€)",
  maxAmount: "Höchstbetrag (€)",
  placeholderMin: "0,00",
  placeholderMax: "Kein Limit",
  clearFilters: "Alle Filter zurücksetzen",
  applyFilters: "Neue Filter anwenden",
  searchTransactions: "Transaktionen suchen",
  unsavedFilters:
    'Sie haben ungespeicherte Filteränderungen. Klicken Sie auf „Neue Filter anwenden", um zu suchen.',
  transactionsTitle: "Transaktionen",
  results_one: "{{count}} Ergebnis",
  results_other: "{{count}} Ergebnisse",
  loadingTransactions: "Transaktionen werden geladen...",
  emptyTitle: "Keine Transaktionen gefunden",
  emptyDescFiltered: "Passen Sie Ihre Filter an",
  emptyDescDefault: "Ihre Transaktionen erscheinen hier",
} as const;
